import { render, staticRenderFns } from "./ImageLayer.vue?vue&type=template&id=88e108fc&scoped=true"
import script from "./ImageLayer.vue?vue&type=script&lang=js"
export * from "./ImageLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e108fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88e108fc')) {
      api.createRecord('88e108fc', component.options)
    } else {
      api.reload('88e108fc', component.options)
    }
    module.hot.accept("./ImageLayer.vue?vue&type=template&id=88e108fc&scoped=true", function () {
      api.rerender('88e108fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/psd-layers/layer-views/ImageLayer.vue"
export default component.exports